/** @format */

export const ChatLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0003 4C8.66699 4 2.66699 8.77333 2.66699 14.6667C2.73366 17.5333 4.08033 20.2267 6.33366 22C6.33366 22.8 5.77366 24.8933 2.66699 28C5.82699 27.8533 8.85366 26.6667 11.2937 24.6667C12.8137 25.1067 14.4137 25.3333 16.0003 25.3333C23.3337 25.3333 29.3337 20.56 29.3337 14.6667C29.3337 8.77333 23.3337 4 16.0003 4ZM16.0003 22.6667C10.107 22.6667 5.33366 19.08 5.33366 14.6667C5.33366 10.2533 10.107 6.66667 16.0003 6.66667C21.8937 6.66667 26.667 10.2533 26.667 14.6667C26.667 19.08 21.8937 22.6667 16.0003 22.6667Z"
                fill={color}
            />
        </svg>
    );
};
